import { Component, Input} from '@angular/core';
import { SessionService } from '../../services/session';


@Component({
  selector: 'app-studio-list-item',
  templateUrl: 'studio-list-item.html'
})
export class StudioListItemComponent {
  @Input() studio: any;
  constructor(public sessionService: SessionService){

  }
}



// WEBPACK FOOTER //
// ./src/components/studio-list-item/studio-list-item.ts